let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hOtIt")).then(() => parcelRequire('lx8ik'));